import React from "react";
import { FEATURES_CONFIG } from "../../../featuresConfig";
import SceneTransitionOverlay from "../SceneTransitionOverlay/SceneTransitionOverlay";

const Transitions = () => {
  return (
    <>
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <SceneTransitionOverlay />}
    </>
  );
};

export default Transitions;
